import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import AuthLayout from './components/layout/AuthLayout';
import LoginPage from './pages/Login/LoginPage';
import ForgotPasswordPage from './pages/ForgotPassword/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPassword/ResetPasswordPage';
import SubscriptionPage from './pages/Subscription/SubscriptionPage';
import NotFoundPage from './pages/NotFound/NotFoundPage';

function App() {
  return (
    <>
      <Toaster position="top-center" richColors theme="light" />
      <AuthLayout>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/forgot-password/:id/:token" element={<ResetPasswordPage />} />
          <Route path="/subscription/:id/:token" element={<SubscriptionPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthLayout>
    </>
  );
}

export default App;
